import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../../cmsConfig';
import {
  NewContractSaveFormRequest,
  NewContractStartTexts,
  NewContractTexts,
} from '../../../types/Application/newContract';
import { SaveFormResponse } from '../../../types/Application/application';

export const newContractApi = createApi({
  reducerPath: 'newContractApi',
  baseQuery: fetchBaseQuery({ baseUrl: cmsApiConfig.url }),
  endpoints: (builder) => ({
    getNewContractStartTexts: builder.query<NewContractStartTexts, void>({
      query: () => `/newContract/getStartTexts/`,
    }),
    getNewContractFullTexts: builder.query<NewContractTexts, void>({
      query: () => `/newContract/getFullTexts`,
    }),
    saveFormNewContract: builder.mutation<any, NewContractSaveFormRequest>({
      query: (formData) => ({
        url: `/newContract/saveForm/`,
        method: 'POST',
        body: formData,
        cache: 'no-cache',
      }),
      transformResponse: (res: SaveFormResponse) => {
        if ('signingUrl' in res) {
          return { statusCode: res.statusCode, signingUrl: res.signingUrl };
        } else {
          return { statusCode: res.statusCode };
        }
      },
      transformErrorResponse: (res) => {
        const { status } = res;
        return status;
      },
    }),
  }),
});

export const {
  useLazyGetNewContractStartTextsQuery,
  useLazyGetNewContractFullTextsQuery,
  useSaveFormNewContractMutation,
} = newContractApi;
